import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtUpdateUserConversationLandingComp from '@/features/userConversations/EtUpdateUserConversationLandingComp'

const EtModalUpdateUserConversationLanding = ({
  isOpen,
  onClose = () => {},
  userId,
  userOrgId,

  conversationMaster,        // 👈 canonical record
  weekStarting,

  refetchUserConversations = () => {},
  allUsers=[], // 06 Feb 2026
}) => {

    // First Created -  23 Jan 2026  
    // Author -  Atul Pandey  
    // Purpose -  Modal wrapper for updating a user conversation from the landing page


  console.log('allUsers in EtModalUpdateUserConversationLanding :', allUsers)

  if (!isOpen || !conversationMaster) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-4xl">
        
        {/* Close Button */}
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
        </div>

        {/* Main Conversation Component */}
        <EtUpdateUserConversationLandingComp
          userId={userId}
          userOrgId={userOrgId}
          allUsers={allUsers}                     // 06 Feb 2026
          conversationMaster={conversationMaster}
          weekStarting={weekStarting}
          onClose={onClose}
          refetchUserConversations={refetchUserConversations}
        />
      </div>
    </div>
  )
}

export default EtModalUpdateUserConversationLanding
